export default {
    init() {
        const blocks = document.querySelectorAll('.ai-two-column-alternating--tabbed');
        if( blocks.length > 0 ){
            console.log(blocks);
            blocks.forEach((block) => {
                const tabButtons = block.querySelectorAll(`.tab-column__cta`);
                const tabs = block.querySelectorAll('.row--tabbed-item');
                tabButtons.forEach((tabButton) => {
                    console.log(tabButton);
                    tabButton.addEventListener('click', (e) => {

                        const tabTarget = e.target.dataset.tabTarget;
                        let tab = block.querySelector(`[data-tab="${tabTarget}"]`);
                        let button = e.target;
                        if(button.classList.contains('tab-column__cta--active') || tab.classList.contains('row-tabbed-item--active') ) {
                            return;
                        }
                        tabs.forEach( (item) => {
                            if(!item.classList.contains('row--tabbed-item-active')) {
                                return;
                            }
                            item.classList.remove('row--tabbed-item-active');
                        })
                        tabButtons.forEach( (item) => {
                            if(!item.classList.contains('tab-column__cta--active')) {
                                return;
                            }
                            item.classList.remove('tab-column__cta--active');
                        } )
                        tab.classList.add('row--tabbed-item-active');
                        button.classList.add('tab-column__cta--active');


                    });
                });
            })
        }
    }
}